module.exports = __webpack_public_path__ + "static/img/on1.457b4e18.png";